<template>
    <div v-if="config.display" :style="{'width': config.width || '100%'}" class="control"  v-bind="config" :data-test-id="dataTestId">
        <label-wrapper :label-settings="config"></label-wrapper>
        <div v-if="asField">
            <display-value :id="config.id"><span class="time">{{value}}</span></display-value>
        </div>
        <div v-else>
            <ejs-timepicker
                v-bind="formattedConfig"
                v-model="formattedValue"
                :data-test-id="dataTestId"
                :enabled="!config.disabled"
                :change="change"
            ></ejs-timepicker>
            <p v-if="config.message" class="input-info" v-html="ddStoreFilter(config.message)"></p>
        </div>
    </div>
</template>

<script>
import { defineAsyncComponent } from "@common/defineAsyncComponent";
import { controlMixins } from "./controlMixins.js";

let editorSettings = {
    onchange: {
        type: 'actionfield',
        label: 'Change Action',
        itemsSource: 'actionStore.getActionOptions()',
        fields: {
            text: 'text',
            value: 'value'
        },
        default: {
            action: '',
            params: {}
        }
    }
};

export const timeComponent = {
    editorSettings: editorSettings,
    mixins: [controlMixins],
    methods: {
        change: function (event) {
            // this.value = event.value ? event.value : null;
            this.action(event, 'onchange');
        }
    },
    computed: {
        formattedValue: {
            get() {
                if (this.config.valueAsNumber && typeof this.value !== 'object') {
                    let date = new Date();
                    date.setHours(Math.floor(this.value / 60));
                    date.setMinutes(this.value % 60);
                    return date;
                }
                return this.value;
            },
            set(value) {
                if (this.config.valueAsNumber && typeof value === 'object' && typeof value?.getTime === 'function') {
                    this.value = (value.getHours() * 60) + value.getMinutes();
                }
                else this.value = value;
            }
        },
        formattedConfig() {
            let config = library.cloneObj(this.config);
            delete config.type;
            delete config.value;
            return config;
        }
    },
    components: {
        'ejs-timepicker': defineAsyncComponent(() => import('@common/syncfusion/timePicker'))
    }
};

export default timeComponent;
</script>
